import { TherapyJobStatus } from '~/app/enums/TherapyJobStatus';
import { TherapyJobV2 } from '~/app/models/TherapyJobV2';

export const noVolumeProvided = (tj: Partial<TherapyJobV2>) => {
  const noVolume = !tj.totalVolumePrescribed && !tj.totalVolumeEdited;
  const prescribed = tj.status === TherapyJobStatus.PRESCRIBED;
  const running = tj.status === TherapyJobStatus.RUNNING;

  return (prescribed || running) && noVolume;
};
